var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelTorsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41051",
    "data-name": "Group 41051",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 477.916,
    height: 418.974,
    viewBox: "0 0 477.916 418.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-10, .cls-17, .cls-18, .cls-9 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #4eb2a2;\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: 0.8;\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clip-path-3);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-7 {\r\n        opacity: 0.3;\r\n      }\r\n\r\n      .cls-8 {\r\n        clip-path: url(#clip-path-4);\r\n      }\r\n\r\n      .cls-10, .cls-9 {\r\n        stroke: #000;\r\n      }\r\n\r\n      .cls-18, .cls-9 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-10, .cls-17 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-11 {\r\n        clip-path: url(#clip-path-5);\r\n      }\r\n\r\n      .cls-12 {\r\n        clip-path: url(#clip-path-6);\r\n      }\r\n\r\n      .cls-13 {\r\n        clip-path: url(#clip-path-7);\r\n      }\r\n\r\n      .cls-14 {\r\n        clip-path: url(#clip-path-8);\r\n      }\r\n\r\n      .cls-15 {\r\n        clip-path: url(#clip-path-9);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #012d35;\r\n      }\r\n\r\n      .cls-17, .cls-18 {\r\n        stroke: #012d35;\r\n      }\r\n\r\n      .cls-18 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #a6a6a6;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #c3c3c3;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #777;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7882",
    "data-name": "Rectangle 7882",
    className: "cls-1",
    width: 477.916,
    height: 418.974
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7841",
    "data-name": "Rectangle 7841",
    className: "cls-1",
    width: 477.916,
    height: 418.262
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7843",
    "data-name": "Rectangle 7843",
    className: "cls-1",
    width: 57.33,
    height: 60.35,
    transform: "translate(9.255 45.054)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7845",
    "data-name": "Rectangle 7845",
    className: "cls-1",
    width: 57.34,
    height: 60.36,
    transform: "translate(396.486 175.604)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7847",
    "data-name": "Rectangle 7847",
    className: "cls-1",
    width: 57.33,
    height: 60.36,
    transform: "translate(116.986 321.076)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7849",
    "data-name": "Rectangle 7849",
    className: "cls-1",
    width: 77.04,
    height: 80.94,
    transform: "translate(9.255 168.474)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7851",
    "data-name": "Rectangle 7851",
    className: "cls-1",
    width: 38.22,
    height: 40.39,
    transform: "translate(34.896 317.46)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7853",
    "data-name": "Rectangle 7853",
    className: "cls-1",
    width: 38.22,
    height: 40.4,
    transform: "translate(423.225 25.954)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41050",
    "data-name": "Group 41050",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41049",
    "data-name": "Group 41049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41048",
    "data-name": "Group 41048",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40829",
    "data-name": "Path 40829",
    className: "cls-3",
    d: "M390.586,24.634s-54.24-40.07-123.57-18-97.54,81.68-136.81,123.61c-20.58,22-51.34,31.11-75.92,48.41-78.61,55.33-64.95,171-3,212,53.659,35.53,120,36.47,205.779,4.53s147.271-51.53,199.411-134.15,1-181.7-65.89-236.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41029",
    "data-name": "Group 41029",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41028",
    "data-name": "Group 41028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41027",
    "data-name": "Group 41027",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40830",
    "data-name": "Path 40830",
    className: "cls-6",
    d: "M390.586,24.634s-54.24-40.07-123.57-18-97.54,81.68-136.81,123.61c-20.58,22-51.34,31.11-75.92,48.41-78.61,55.33-64.95,171-3,212,53.659,35.53,120,36.47,205.779,4.53s147.271-51.53,199.411-134.15,1-181.7-65.89-236.4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41032",
    "data-name": "Group 41032",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41031",
    "data-name": "Group 41031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41030",
    "data-name": "Group 41030",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40831",
    "data-name": "Path 40831",
    className: "cls-6",
    d: "M66.086,104.9H18.506V45.554h40.48l7.1,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40832",
    "data-name": "Path 40832",
    className: "cls-9",
    d: "M66.086,104.9H18.506V45.554h40.48l7.1,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40833",
    "data-name": "Path 40833",
    className: "cls-6",
    d: "M58.986,45.554v6.02h7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40834",
    "data-name": "Path 40834",
    className: "cls-9",
    d: "M58.986,45.554v6.02h7.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7842",
    "data-name": "Rectangle 7842",
    width: 35.52,
    height: 12.97,
    transform: "translate(9.255 50.544)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    className: "cls-10",
    x2: 38.31,
    transform: "translate(23.765 67.224)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    className: "cls-10",
    x2: 38.31,
    transform: "translate(23.765 74.334)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    className: "cls-10",
    x2: 38.31,
    transform: "translate(23.765 81.434)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    className: "cls-10",
    x2: 38.31,
    transform: "translate(23.765 88.544)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    className: "cls-10",
    x2: 38.31,
    transform: "translate(23.765 95.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40835",
    "data-name": "Path 40835",
    className: "cls-6",
    d: "M20.1,61.664v-8.41h-1.72v-1h4.47v1h-1.72v8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40836",
    "data-name": "Path 40836",
    className: "cls-6",
    d: "M25.885,57.634l-1.57,4h-1l1.89-4.82-1.73-4.51h1.09l1.44,3.75,1.47-3.75h1l-1.75,4.54,1.87,4.82h-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40837",
    "data-name": "Path 40837",
    className: "cls-6",
    d: "M30.726,61.664v-8.41H29v-1h4.48v1h-1.73v8.41Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41035",
    "data-name": "Group 41035",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41034",
    "data-name": "Group 41034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41033",
    "data-name": "Group 41033",
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40838",
    "data-name": "Path 40838",
    className: "cls-6",
    d: "M453.326,235.464h-47.58V176.1h40.47l7.11,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40839",
    "data-name": "Path 40839",
    className: "cls-9",
    d: "M453.326,235.464h-47.58V176.1h40.47l7.11,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40840",
    "data-name": "Path 40840",
    className: "cls-6",
    d: "M446.216,176.1v6.02h7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40841",
    "data-name": "Path 40841",
    className: "cls-9",
    d: "M446.216,176.1v6.02h7.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7844",
    "data-name": "Rectangle 7844",
    width: 35.52,
    height: 12.97,
    transform: "translate(396.486 181.104)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(411.005 197.784)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    "data-name": "Line 120",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(411.005 204.884)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(411.005 211.984)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(411.005 219.094)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(411.005 226.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40842",
    "data-name": "Path 40842",
    className: "cls-6",
    d: "M407.336,192.224v-8.41h-1.73v-.95h4.48v.95h-1.72v8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40843",
    "data-name": "Path 40843",
    className: "cls-6",
    d: "M413.125,188.184l-1.57,4h-1l1.89-4.83-1.77-4.53h1.08l1.45,3.74,1.46-3.74h1l-1.75,4.53,1.87,4.83h-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40844",
    "data-name": "Path 40844",
    className: "cls-6",
    d: "M417.956,192.224v-8.41h-1.72v-.95h4.48v.95h-1.73v8.41Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41038",
    "data-name": "Group 41038",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41037",
    "data-name": "Group 41037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41036",
    "data-name": "Group 41036",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40845",
    "data-name": "Path 40845",
    className: "cls-6",
    d: "M173.816,380.935h-47.58v-59.36h40.48l7.1,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40846",
    "data-name": "Path 40846",
    className: "cls-9",
    d: "M173.816,380.935h-47.58v-59.36h40.48l7.1,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40847",
    "data-name": "Path 40847",
    className: "cls-6",
    d: "M166.715,321.576v6.03h7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40848",
    "data-name": "Path 40848",
    className: "cls-9",
    d: "M166.715,321.576v6.03h7.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7846",
    "data-name": "Rectangle 7846",
    width: 35.52,
    height: 12.97,
    transform: "translate(116.986 326.575)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(131.505 343.255)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(131.505 350.355)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(131.505 357.456)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    "data-name": "Line 127",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(131.505 364.565)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    className: "cls-10",
    x2: 38.3,
    transform: "translate(131.505 371.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40849",
    "data-name": "Path 40849",
    className: "cls-6",
    d: "M127.826,337.7v-8.41h-1.72v-.95h4.48v.95h-1.73v8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40850",
    "data-name": "Path 40850",
    className: "cls-6",
    d: "M133.615,333.656l-1.57,4h-1l1.88-4.83-1.76-4.53h1.08l1.44,3.74,1.46-3.74h1l-1.76,4.53,1.88,4.83h-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40851",
    "data-name": "Path 40851",
    className: "cls-6",
    d: "M138.505,337.7v-8.41h-1.73v-.95h4.48v.95h-1.75v8.41Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41041",
    "data-name": "Group 41041",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41040",
    "data-name": "Group 41040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41039",
    "data-name": "Group 41039",
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40852",
    "data-name": "Path 40852",
    className: "cls-6",
    d: "M85.8,248.914H21.715v-79.94h54.52l9.56,7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40853",
    "data-name": "Path 40853",
    className: "cls-9",
    d: "M85.8,248.914H21.715v-79.94h54.52l9.56,7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40854",
    "data-name": "Path 40854",
    className: "cls-6",
    d: "M76.235,168.974v8.11H85.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40855",
    "data-name": "Path 40855",
    className: "cls-9",
    d: "M76.235,168.974v8.11H85.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7848",
    "data-name": "Rectangle 7848",
    width: 47.84,
    height: 17.47,
    transform: "translate(9.255 175.704)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    className: "cls-10",
    x2: 51.59,
    transform: "translate(28.806 198.164)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    className: "cls-10",
    x2: 51.59,
    transform: "translate(28.806 207.734)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    className: "cls-10",
    x2: 51.59,
    transform: "translate(28.806 217.294)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    className: "cls-10",
    x2: 51.59,
    transform: "translate(28.806 226.864)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    className: "cls-10",
    x2: 51.59,
    transform: "translate(28.806 236.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40856",
    "data-name": "Path 40856",
    className: "cls-6",
    d: "M24.8,178.074c2,0,2.83,1.17,2.83,3.08v1.51c0,2-.94,3-2.94,3h-1.21v5h-1.4v-12.6Zm-.11,6.39c1,0,1.55-.49,1.55-1.69v-1.68c0-1.15-.41-1.73-1.44-1.73h-1.32v5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40857",
    "data-name": "Path 40857",
    className: "cls-6",
    d: "M31.726,178.074c2,0,2.859,1.18,2.859,3.13v6.35c0,1.93-.9,3.12-2.859,3.12h-3v-12.6Zm0,11.32c1,0,1.5-.63,1.5-1.78v-6.48c0-1.16-.49-1.79-1.511-1.79H30.176v10.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40858",
    "data-name": "Path 40858",
    className: "cls-6",
    d: "M40.206,183.944v1.27h-2.9v5.46h-1.4v-12.6h5v1.27h-3.6v4.6Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41044",
    "data-name": "Group 41044",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41043",
    "data-name": "Group 41043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41042",
    "data-name": "Group 41042",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40859",
    "data-name": "Path 40859",
    className: "cls-6",
    d: "M72.616,357.35H41.035v-39.39H67.9l4.72,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40860",
    "data-name": "Path 40860",
    className: "cls-9",
    d: "M72.616,357.35H41.035v-39.39H67.9l4.72,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40861",
    "data-name": "Path 40861",
    className: "cls-6",
    d: "M67.9,317.961v4h4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40862",
    "data-name": "Path 40862",
    className: "cls-9",
    d: "M67.9,317.961v4h4.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7850",
    "data-name": "Rectangle 7850",
    width: 23.57,
    height: 8.61,
    transform: "translate(34.895 321.27)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(44.535 332.341)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(44.535 337.06)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(44.535 341.771)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(44.535 346.491)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(44.535 351.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40863",
    "data-name": "Path 40863",
    className: "cls-6",
    d: "M42.556,322.44c1,0,1.389.581,1.389,1.521v.74c0,1-.459,1.5-1.45,1.5h-.61v2.449h-.69v-6.21Zm-.061,3.11c.52,0,.77-.239.77-.83v-.83c0-.56-.209-.85-.709-.85h-.671v2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40864",
    "data-name": "Path 40864",
    className: "cls-6",
    d: "M45.965,322.44c1,0,1.41.591,1.41,1.551v3.129c0,.951-.439,1.53-1.41,1.53h-1.45v-6.21Zm0,5.581c.5,0,.741-.31.741-.88v-3.19c0-.57-.241-.88-.75-.88h-.741v5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40865",
    "data-name": "Path 40865",
    className: "cls-6",
    d: "M50.146,325.331v.63h-1.43v2.69h-.69v-6.21H50.5v.63h-1.78v2.26Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41047",
    "data-name": "Group 41047",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41046",
    "data-name": "Group 41046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41045",
    "data-name": "Group 41045",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40866",
    "data-name": "Path 40866",
    className: "cls-6",
    d: "M460.945,65.854h-31.58v-39.4h26.86l4.72,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40867",
    "data-name": "Path 40867",
    className: "cls-9",
    d: "M460.945,65.854h-31.58v-39.4h26.86l4.72,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40868",
    "data-name": "Path 40868",
    className: "cls-6",
    d: "M456.225,26.454v4h4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40869",
    "data-name": "Path 40869",
    className: "cls-9",
    d: "M456.225,26.454v4h4.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7852",
    "data-name": "Rectangle 7852",
    width: 23.57,
    height: 8.61,
    transform: "translate(423.225 29.774)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_139",
    "data-name": "Line 139",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(432.855 40.844)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_140",
    "data-name": "Line 140",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(432.855 45.554)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    "data-name": "Line 141",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(432.855 50.274)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_142",
    "data-name": "Line 142",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(432.855 54.984)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    "data-name": "Line 143",
    className: "cls-10",
    x2: 25.42,
    transform: "translate(432.855 59.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40870",
    "data-name": "Path 40870",
    className: "cls-6",
    d: "M430.885,30.944c1,0,1.391.57,1.391,1.52v.74c0,1-.461,1.5-1.45,1.5h-.61v2.45h-.69v-6.21Zm-.059,3.14c.519,0,.769-.24.769-.84v-.78c0-.57-.21-.85-.71-.85h-.669v2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40871",
    "data-name": "Path 40871",
    className: "cls-6",
    d: "M434.3,30.944c1,0,1.41.58,1.41,1.54v3.13c0,.95-.44,1.54-1.41,1.54h-1.451v-6.21Zm0,5.58c.5,0,.739-.31.739-.88v-3.18c0-.57-.239-.88-.75-.88h-.739v5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40872",
    "data-name": "Path 40872",
    className: "cls-6",
    d: "M438.475,33.834v.63h-1.43v2.69h-.69v-6.21h2.47v.63h-1.78v2.26Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7854",
    "data-name": "Rectangle 7854",
    className: "cls-16",
    width: 334.46,
    height: 261.41,
    transform: "translate(75.921 36.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7855",
    "data-name": "Rectangle 7855",
    className: "cls-17",
    width: 334.46,
    height: 261.41,
    transform: "translate(75.921 36.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7856",
    "data-name": "Rectangle 7856",
    className: "cls-3",
    width: 335.47,
    height: 262.03,
    transform: "translate(86.771 25.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7857",
    "data-name": "Rectangle 7857",
    className: "cls-6",
    width: 335.47,
    height: 262.03,
    transform: "translate(86.771 25.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7858",
    "data-name": "Rectangle 7858",
    className: "cls-18",
    width: 335.47,
    height: 262.03,
    transform: "translate(86.771 25.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7859",
    "data-name": "Rectangle 7859",
    className: "cls-6",
    width: 71,
    height: 45,
    transform: "translate(95.9 62.904)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7860",
    "data-name": "Rectangle 7860",
    className: "cls-18",
    width: 71,
    height: 45,
    transform: "translate(95.9 62.904)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    "data-name": "Line 144",
    className: "cls-17",
    x2: 30,
    transform: "translate(115.4 82.414)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    className: "cls-17",
    x2: 49.5,
    transform: "translate(107.9 89.914)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7861",
    "data-name": "Rectangle 7861",
    className: "cls-6",
    width: 71,
    height: 45,
    transform: "translate(95.9 116.404)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7862",
    "data-name": "Rectangle 7862",
    className: "cls-18",
    width: 71,
    height: 45,
    transform: "translate(95.9 116.404)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 127.084)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 133.044)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 139.004)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    "data-name": "Line 149",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 144.964)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 150.924)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 127.084)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 133.044)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 139.004)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_154",
    "data-name": "Line 154",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 144.964)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_155",
    "data-name": "Line 155",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 150.924)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7863",
    "data-name": "Rectangle 7863",
    className: "cls-6",
    width: 71,
    height: 45,
    transform: "translate(95.9 169.904)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7864",
    "data-name": "Rectangle 7864",
    className: "cls-18",
    width: 71,
    height: 45,
    transform: "translate(95.9 169.904)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 180.584)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 186.544)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    "data-name": "Line 158",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 192.504)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 198.464)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_160",
    "data-name": "Line 160",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 204.424)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    "data-name": "Line 161",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 180.584)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    "data-name": "Line 162",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 186.544)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_163",
    "data-name": "Line 163",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 192.504)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_164",
    "data-name": "Line 164",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 198.464)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    "data-name": "Line 165",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 204.424)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7865",
    "data-name": "Rectangle 7865",
    className: "cls-6",
    width: 71,
    height: 45,
    transform: "translate(95.9 223.404)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7866",
    "data-name": "Rectangle 7866",
    className: "cls-18",
    width: 71,
    height: 45,
    transform: "translate(95.9 223.404)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_166",
    "data-name": "Line 166",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 234.084)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_167",
    "data-name": "Line 167",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 240.044)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_168",
    "data-name": "Line 168",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 246.004)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 251.964)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(103.29 257.924)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 234.084)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 240.044)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 246.004)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 251.964)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    className: "cls-17",
    x2: 24.9,
    transform: "translate(134.12 257.924)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7867",
    "data-name": "Rectangle 7867",
    className: "cls-19",
    width: 245.33,
    height: 262.03,
    transform: "translate(176.9 25.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7868",
    "data-name": "Rectangle 7868",
    className: "cls-18",
    width: 245.33,
    height: 262.03,
    transform: "translate(176.9 25.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7869",
    "data-name": "Rectangle 7869",
    className: "cls-6",
    width: 222,
    height: 151,
    transform: "translate(183.9 75.414)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7870",
    "data-name": "Rectangle 7870",
    className: "cls-18",
    width: 222,
    height: 151,
    transform: "translate(183.9 75.414)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    className: "cls-17",
    x2: 121.84,
    transform: "translate(235.48 135.354)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    className: "cls-17",
    x2: 154.96,
    transform: "translate(218.921 148.594)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7871",
    "data-name": "Rectangle 7871",
    className: "cls-20",
    width: 8.67,
    height: 262.03,
    transform: "translate(413.561 25.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7872",
    "data-name": "Rectangle 7872",
    className: "cls-17",
    width: 8.67,
    height: 262.03,
    transform: "translate(413.561 25.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7873",
    "data-name": "Rectangle 7873",
    className: "cls-21",
    width: 8.67,
    height: 70.8,
    transform: "translate(413.561 106.954)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7874",
    "data-name": "Rectangle 7874",
    className: "cls-3",
    width: 335.47,
    height: 17.02,
    transform: "translate(86.771 25.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7875",
    "data-name": "Rectangle 7875",
    className: "cls-18",
    width: 335.47,
    height: 17.02,
    transform: "translate(86.771 25.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7876",
    "data-name": "Rectangle 7876",
    className: "cls-6",
    width: 215.68,
    height: 9.6,
    transform: "translate(108.831 28.674)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    className: "cls-17",
    x1: 16.65,
    transform: "translate(389.241 48.814)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    className: "cls-17",
    x1: 16.65,
    transform: "translate(389.241 53.944)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_180",
    "data-name": "Line 180",
    className: "cls-17",
    x1: 16.65,
    transform: "translate(389.241 59.064)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    className: "cls-18",
    y1: 11.58,
    x2: 4.05,
    transform: "translate(420.475 358.324)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_182",
    "data-name": "Line 182",
    className: "cls-18",
    y2: 43.14,
    transform: "translate(420.766 338.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40873",
    "data-name": "Path 40873",
    className: "cls-3",
    d: "M414.125,361.014s-6-6.55-12-5.46-8.74,8.2-8.74,12.57,6,18.57,6,18.57,4.37-4.91,14.21-12,10.37-14.23.53-13.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40874",
    "data-name": "Path 40874",
    className: "cls-18",
    d: "M414.125,361.014s-6-6.55-12-5.46-8.74,8.2-8.74,12.57,6,18.57,6,18.57,4.37-4.91,14.21-12S423.965,360.464,414.125,361.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40875",
    "data-name": "Path 40875",
    className: "cls-18",
    d: "M414.125,361.014a30.06,30.06,0,0,0-12,12.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40876",
    "data-name": "Path 40876",
    className: "cls-3",
    d: "M423.926,353.324s5-5.39,9.91-4.48,7.19,6.77,7.18,10.37-5,15.3-5,15.3a78.505,78.505,0,0,0-11.67-9.94c-8.091-5.87-8.53-11.72-.42-11.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40877",
    "data-name": "Path 40877",
    className: "cls-18",
    d: "M423.926,353.324s5-5.39,9.91-4.48,7.19,6.77,7.18,10.37-5,15.3-5,15.3a78.505,78.505,0,0,0-11.67-9.94C416.255,358.7,415.816,352.854,423.926,353.324Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40878",
    "data-name": "Path 40878",
    className: "cls-18",
    d: "M423.926,353.324a24.684,24.684,0,0,1,9.87,10.38"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_183",
    "data-name": "Line 183",
    className: "cls-18",
    y1: 11.01,
    x2: 7.53,
    transform: "translate(419.896 335.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40879",
    "data-name": "Path 40879",
    className: "cls-3",
    d: "M418.635,342.974s-.119-7.32-4.429-9.93-9.861.27-12.25,3-6.481,14.71-6.481,14.71,5.38-.65,15.331.35,14.189-3.09,7.829-8.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40880",
    "data-name": "Path 40880",
    className: "cls-18",
    d: "M418.635,342.974s-.119-7.32-4.429-9.93-9.861.27-12.25,3-6.481,14.71-6.481,14.71,5.38-.65,15.331.35S424.995,348.014,418.635,342.974Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40881",
    "data-name": "Path 40881",
    className: "cls-18",
    d: "M418.635,342.974a24.76,24.76,0,0,0-14.28,1.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40882",
    "data-name": "Path 40882",
    className: "cls-3",
    d: "M425.105,333.154s.09-5.39,3.261-7.31,7.269.2,9,2.18,4.75,10.85,4.75,10.85a57.856,57.856,0,0,0-11.28.26c-7.3.73-10.361-2.27-5.731-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40883",
    "data-name": "Path 40883",
    className: "cls-18",
    d: "M425.105,333.154s.09-5.39,3.261-7.31,7.269.2,9,2.18,4.75,10.85,4.75,10.85a57.856,57.856,0,0,0-11.28.26C423.535,339.864,420.475,336.864,425.105,333.154Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40884",
    "data-name": "Path 40884",
    className: "cls-18",
    d: "M425.105,333.154a18.216,18.216,0,0,1,10.511.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40885",
    "data-name": "Path 40885",
    className: "cls-6",
    d: "M439.165,378.074h-38.81l3.93,40.4h30.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40886",
    "data-name": "Path 40886",
    className: "cls-18",
    d: "M439.165,378.074h-38.81l3.93,40.4h30.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40887",
    "data-name": "Path 40887",
    className: "cls-16",
    d: "M428.875,395.674a1.73,1.73,0,1,0,0-.02v.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40888",
    "data-name": "Path 40888",
    className: "cls-18",
    d: "M428.875,395.674a1.73,1.73,0,1,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40889",
    "data-name": "Path 40889",
    className: "cls-16",
    d: "M422.475,395.674a1.73,1.73,0,1,0,0-.02v.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40890",
    "data-name": "Path 40890",
    className: "cls-18",
    d: "M422.475,395.674a1.73,1.73,0,1,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40891",
    "data-name": "Path 40891",
    className: "cls-16",
    d: "M401.646,391.324h36.23l.17-1.73h-36.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40892",
    "data-name": "Path 40892",
    className: "cls-18",
    d: "M401.646,391.324h36.23l.17-1.73h-36.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40893",
    "data-name": "Path 40893",
    className: "cls-16",
    d: "M436.326,407.254l.73-7.53h-34.59l.73,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40894",
    "data-name": "Path 40894",
    className: "cls-18",
    d: "M436.326,407.254l.73-7.53h-34.59l.73,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40895",
    "data-name": "Path 40895",
    className: "cls-16",
    d: "M435.246,395.674a1.731,1.731,0,0,0,1.73,1.73h.31l.319-3.32a1.793,1.793,0,0,0-.619-.12,1.74,1.74,0,0,0-1.74,1.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40896",
    "data-name": "Path 40896",
    className: "cls-18",
    d: "M435.246,395.674a1.731,1.731,0,0,0,1.73,1.73h.31l.319-3.32a1.793,1.793,0,0,0-.619-.12A1.74,1.74,0,0,0,435.246,395.674Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40897",
    "data-name": "Path 40897",
    className: "cls-16",
    d: "M416.135,395.674a1.73,1.73,0,1,0,0-.02v.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40898",
    "data-name": "Path 40898",
    className: "cls-18",
    d: "M416.135,395.674a1.73,1.73,0,1,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40899",
    "data-name": "Path 40899",
    className: "cls-16",
    d: "M403.4,395.674a1.73,1.73,0,1,0,0-.02v.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40900",
    "data-name": "Path 40900",
    className: "cls-18",
    d: "M403.4,395.674a1.73,1.73,0,1,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40901",
    "data-name": "Path 40901",
    className: "cls-16",
    d: "M409.766,395.674a1.73,1.73,0,1,0,0-.02v.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40902",
    "data-name": "Path 40902",
    className: "cls-18",
    d: "M409.766,395.674a1.73,1.73,0,1,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7877",
    "data-name": "Rectangle 7877",
    className: "cls-19",
    width: 209.55,
    height: 5.99,
    transform: "translate(162.565 412.484)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7878",
    "data-name": "Rectangle 7878",
    className: "cls-18",
    width: 209.55,
    height: 5.99,
    transform: "translate(162.565 412.484)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7879",
    "data-name": "Rectangle 7879",
    className: "cls-16",
    width: 73.56,
    height: 5.99,
    transform: "translate(162.565 412.484)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7880",
    "data-name": "Rectangle 7880",
    className: "cls-18",
    width: 73.56,
    height: 5.99,
    transform: "translate(162.565 412.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40903",
    "data-name": "Path 40903",
    className: "cls-16",
    d: "M230.2,412.464h136.06l7.86-90.49a7.049,7.049,0,0,0-7.13-7.81H246.535a8.691,8.691,0,0,0-8.48,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40904",
    "data-name": "Path 40904",
    className: "cls-18",
    d: "M230.2,412.464h136.06l7.86-90.49a7.049,7.049,0,0,0-7.13-7.81H246.535a8.691,8.691,0,0,0-8.48,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40905",
    "data-name": "Path 40905",
    className: "cls-19",
    d: "M232.8,412.464h136.06l7.86-90.49a7.049,7.049,0,0,0-7.13-7.81H249.145a8.691,8.691,0,0,0-8.48,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40906",
    "data-name": "Path 40906",
    className: "cls-18",
    d: "M232.8,412.464h136.06l7.86-90.49a7.049,7.049,0,0,0-7.13-7.81H249.145a8.691,8.691,0,0,0-8.48,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40907",
    "data-name": "Path 40907",
    className: "cls-16",
    d: "M301.746,360.464a9.489,9.489,0,0,1,9.27-8.53,7.7,7.7,0,0,1,7.834,7.564,7.8,7.8,0,0,1-.044.966,9.49,9.49,0,0,1-9.27,8.53,7.7,7.7,0,0,1-7.834-7.564,7.8,7.8,0,0,1,.044-.966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40908",
    "data-name": "Path 40908",
    className: "cls-18",
    d: "M301.746,360.464a9.489,9.489,0,0,1,9.27-8.53,7.7,7.7,0,0,1,7.834,7.564,7.8,7.8,0,0,1-.044.966,9.49,9.49,0,0,1-9.27,8.53,7.7,7.7,0,0,1-7.834-7.564A7.8,7.8,0,0,1,301.746,360.464Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    className: "cls-17",
    x1: 468.61,
    transform: "translate(6.896 418.474)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelTorsImg);
export default __webpack_public_path__ + "static/media/model_tors_Img.f906b78be794dc7d2772dd24048d03a2.svg";
export { ForwardRef as ReactComponent };